import { render, staticRenderFns } from "./studioDashboardOpeningHours.vue?vue&type=template&id=1bdf92f9&scoped=true"
import script from "./studioDashboardOpeningHours.vue?vue&type=script&lang=js"
export * from "./studioDashboardOpeningHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf92f9",
  null
  
)

export default component.exports